import GtmUserFeeds from 'desktop/initializers/gtm_user_feeds';
import ClipboardJS from 'clipboard/dist/clipboard.min';
import GtmWatch from 'desktop/initializers/gtm_watch';
import Popup from 'shared/components/popups/popup';
import SocialTracker from 'shared/social_tracker';
import UrlUtils from 'shared/url_utils';

const embedLivePopup = require('templates/popups/embed_livestreaming.jst.jade');
const embedPopup = require('templates/popups/embed.jst.jade')

export default class EmbedPopup {
  constructor({$element: $element}) {
    this.ui = {
      root: ".popup-embed",
      popupTab: ".popup-embed__tab",
      code: ".popup-embed__input-code",
      iframe: ".popup-embed__preview-iframe",
      autoplay: 'input.popup-embed__autoplay[type="checkbox"]',
      playerOnly: 'input.popup-embed__player-only[type="checkbox"]',
      playerOnlyContainer: '.popup-embed__input-player-only',
      liveChat: 'input.popup-embed__live-chat[type="checkbox"]',
      copy: '.popup-embed__copy',
      url: '.popup-embed__copy-url .form #share-url',
      link: '.popup-embed__copy-url .form button.js__clipboard',
      facebook: '.popup-embed__share-facebook',
      twitter: '.popup-embed__share-twitter',
      mute: 'input.popup-embed__mute[type="checkbox"]'
    };
    this.template = "embed";
    this.title = "Embed Vidio";
    this.autoplay = false;
    this.playerOnly = true;
    this.liveChat = false;
    this.embedUrl = "";
    this.watchUrl = "";
    this.videoId = "";
    this.source = "";
    this.html = null;
    this.body = $('body');
    this.className = "";
    this.mute = false;
    this.utm = "?utm_campaign=vidio-share";
    this.hideEmbedTab = "";
    this.tracker = null;
    this.isBoundClickToTrack = false;
    this.$element = $element;
  }

  init() {
    if(this.$element.data('className') !== undefined) {
      this.className = this.$element.data('className');
    }
    this.$element.click(this.onButtonClick.bind(this));
  }

  onButtonClick(e) {
    var dataType = $(e.target).data('type');
    e.preventDefault();
    e.stopPropagation();
    this.embedUrl = $(e.target).data('url-embed');
    this.watchUrl = $(e.target).data('url-watch');
    this.videoId = $(e.target).data('video-id');
    this.source = $(e.target).data('source');
    this.wording = $(e.target).data('wording');
    this.hideEmbedTab = $(e.target).data('hide-embed-tab');
    if (dataType === "livestreaming") {
      this.autoplay = true;
      this.mute = false;
      this.liveChat = false;
    }
    if (!this.tracker) {
      this.tracker = this.createTracker();
    }
    this.render(dataType);
    this.sendGtmPopupImpression(this.source, this.videoId);
    if (dataType === "livestreaming") {
      this.html.find(this.ui.playerOnlyContainer).hide();
    }
    document.getElementsByTagName("body")[0].style.overflow = 'hidden';
    this.body.append(this.html);
    if (window.player) {
      window.player.tech().pause();
    }
  }

  sendGtmPopupImpression(source, videoId){
    if(source == 'feeds'){
      GtmUserFeeds.pushWithType('impression', 'vod.'+videoId,'share','following');
    } else if(source == 'vod-watchpage'){
      GtmWatch.push('impression', 'share', 'watchpage', 'vod.'+videoId);
    }
  }

  bindTabChanged() {
    var tabRootDOM = $(this.ui.iframe).closest(this.ui.popupTab);
    var tabContentDOM = $(this.ui.iframe).closest('.tab-pane');
    var tabLinksWrapperDOM = tabRootDOM.children('.nav.nav-tabs');
    var tabLinksDOM = tabLinksWrapperDOM.children('li');
    var tabLinkDOM = tabLinksWrapperDOM.find('a[href="#' + tabContentDOM.attr('id') + '"]').closest('li');
    var setAutoplay = this.setAutoplay.bind(this);

    tabLinksDOM.on('click', function() {
      if($(this).index() == tabLinkDOM.index()) {
        setAutoplay(true);
      } else {
        setAutoplay(false);
      }
    });
  }

  bindAutoplay(){
    this.html.find(this.ui.autoplay).change(this.onAutoplayChange.bind(this));
  }

  onAutoplayChange(e) {
    this.autoplay = e.target.checked;
    this.setAutoplay(this.autoplay);
    this.setCode(this.url());
  }

  bindMute() {
    this.html.find(this.ui.mute).change(this.onMuteChange.bind(this));
  }

  onMuteChange(e) {
    this.mute = e.target.checked;
    this.setCode(this.url());
    this.setPreview(this.url());
  }

  bindPlayerOnly() {
    this.html.find(this.ui.playerOnly).change(this.onPlayerOnlyChange.bind(this));
  }

  onPlayerOnlyChange(e) {
    this.playerOnly = e.target.checked;
    this.setCode(this.url());
    this.setPreview(this.url());
  }

  bindLiveChat(){
    this.html.find(this.ui.liveChat).change(this.onLiveChatChange.bind(this));
  }

  onLiveChatChange(e) {
    this.liveChat = e.target.checked;
    this.setCode(this.url());
    this.setPreview(this.url());
  }

  bindCopy() {
    new ClipboardJS('.js__clipboard');
  }

  url() {
    return this.embedUrl + '?' + this.autoplayParams() + this.playerOnlyParams() + this.liveChatParams() + this.muteParams();
  }

  autoplayParams() {
    if(this.autoplay) {
      return "autoplay=true&";
    } else {
      return "autoplay=false&";
    }
  }

  playerOnlyParams() {
    if(this.playerOnly) {
      return "player_only=true&";
    } else {
      return "player_only=false&";
    }
  }

  liveChatParams() {
    if(this.liveChat) {
      return "live_chat=true&enable_websocket=true&";
    } else {
      return "live_chat=false&enable_websocket=false&";
    }
  }

  muteParams() {
    if(this.mute) {
      return "mute=true&";
    } else {
      return "mute=false&";
    }
  }

  render(dataType) {
    this.autoplay = false;
    var popup = Popup.new(this.title, this.template);
    var params = {
      url: this.url(),
      className: this.className,
      hideEmbedTab: this.hideEmbedTab
    };
    var content = dataType == 'livestreaming' ? $(embedLivePopup(params)) : $(embedPopup(params));
    this.html = popup.content(content);
    this.bindAutoplay();
    this.bindMute();
    this.bindPlayerOnly();
    this.bindCopy();
    this.bindLiveChat();
    this.setCode(this.url());
    this.setUrl(this.watchUrl);
    this.setVideoId(this.videoId);
    this.setSource(this.source);

    setTimeout(function(){
      this.bindTabChanged();
      GtmUserFeeds.bindEmbedShareButtonClick();
      GtmUserFeeds.bindFacebookShareButtonClick();
      GtmUserFeeds.bindTwitterShareButtonClick();
      GtmWatch.bindEmbedShareButtonClick();
      GtmWatch.bindFacebookShareButtonClick();
      GtmWatch.bindTwitterShareButtonClick();
      this.bindShareButtonsClick();
    }.bind(this), 1000);
  }

  setAutoplay(play) {
    this.autoplay = play;
    var value = (play) ? 'play' : 'pause';
    $(this.ui.iframe)[0].contentWindow.postMessage(value, '*');
    this.setCode(this.url());
  }

  setPreview(url){
    if(this.playerOnly) {
      this.html.find(this.ui.iframe).attr("src", url).addClass('popup-embed__preview-iframe--player-only');
    } else {
      this.html.find(this.ui.iframe).attr("src", url).removeClass('popup-embed__preview-iframe--player-only');
    }
  }

  setCode(url) {
    let height = 520;
    let width = 560;

    if(this.$element.data("width") !== undefined){
      width = this.$element.data("width");
    }

    if(this.$element.data("height") !== undefined){
      height = this.$element.data("height");
    }

    if(this.playerOnly) {
      height = 317;
    }

    let playerHtml = `<iframe class="vidio-embed" src="${url}" width="${width}" height="${height}" scrolling="no" frameborder="0" allowfullscreen></iframe>`
    let chatHtml = `<iframe class="chat-embed" src="${this.embedUrl}_chat" width="${width}" height="${height}" scrolling="no" frameborder="0" allowfullscreen></iframe>`
    let html = `${playerHtml}${this.liveChat ? chatHtml : ''}<script src="//static-web-prod-vidio.akamaized.net/assets/javascripts/vidio-embed.js"></script>`;

    this.html.find(this.ui.code).val(html);
  }

  setUrl(url) {
    const targetUrl = UrlUtils.urlJoin(url, this.utm);
    let shareWording = targetUrl;
    let facebookUrl = this.html.find(this.ui.facebook).attr('href') + targetUrl;
    let twitterUrl = this.html.find(this.ui.twitter).attr('href') + 'url=' + targetUrl;

    if(this.wording)
    {
      shareWording = this.wording + "\n" + shareWording;
      facebookUrl = facebookUrl + '&quote=' + encodeURI(this.wording);
      twitterUrl = twitterUrl + '&text=' + encodeURI(this.wording);
    }

    this.html.find(this.ui.url).val(shareWording);
    this.html.find(this.ui.facebook).attr('href', facebookUrl );
    this.html.find(this.ui.facebook).attr('rel', 'noopener');
    this.html.find(this.ui.twitter).attr('href',  twitterUrl );
    this.html.find(this.ui.twitter).attr('rel', 'noopener');
  }

  setVideoId(video) {
    this.html.find(this.ui.facebook).attr('data-video-id', video);
    this.html.find(this.ui.twitter).attr('data-video-id', video);
    this.html.find(this.ui.popupTab + " #embed-tab").attr('data-video-id', video);
  }

  setSource(source){
    this.html.find(this.ui.popupTab + " #embed-tab").attr('data-source', source);
    this.html.find(this.ui.facebook).attr('data-source', source);
    this.html.find(this.ui.twitter).attr('data-source', source);
  }

  createTracker() {
    if (!this.source) return SocialTracker.createNull();

    let pageName = this.source.replace('-', ' ');
    return SocialTracker.create(pageName);
  }

  bindShareButtonsClick() {
    if (this.isBoundClickToTrack) return;
    this.isBoundClickToTrack = true;

    let utmUrl = UrlUtils.urlJoin(this.watchUrl, this.utm);
    this.html.find(this.ui.facebook).on('click', () => this.tracker.trackShareClick('Facebook', utmUrl));
    this.html.find(this.ui.twitter).on('click', () => this.tracker.trackShareClick('Twitter', utmUrl));
    this.html.find(this.ui.link).on('click', () => this.tracker.trackShareClick('Link', utmUrl));
  }
}
